export const INVALID_ACTION_ID = '-1'
